import React, { useEffect } from "react";

const Loading = ({ articles }) => {
  return (
    <div
      className="widthContainer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        height: "85vh",
        position: "absolute",

        width: "100%",
      }}
    >
      <h1 style={{ color: "black" }}>Loading...</h1>
    </div>
  );
};

export default Loading;
